import { VscTriangleDown, VscTriangleUp } from "react-icons/vsc";
import { BsUpcScan } from "react-icons/bs";
import { BsSearch, BsCalendarDay } from "react-icons/bs";
import { useState, useEffect } from "react";
import CustomeDateSearch from "../filter/CustomeDateSearch";
/* import { CiCalendarDate } from "react-icons/ci"; */
import { MdKeyboardArrowDown } from "react-icons/md";
import { BsBarChartFill } from "react-icons/bs";
import TransactionInsights from "../insights/TransactionInsights.jsx";
import { Search, Calendar, BarChart3, Plus, ScanQrCode, NotebookPen } from "lucide-react";
import QRScannerOverlay, { QRScanner } from "../../screens/stores/makeTansaction/ScanQrCode.jsx";

const StoreSearchTab = ({
  updateTransType,
  transType,
  transID,
  updateQueryID,
  showQueriedTrans,
  getYesterdayTrans,
  getTodayTrans,
  getCustomTrans,
  setDisplayedTimeline,
  displayedTimeline,
  transactionCount,
  transactionInsights,
  searchString,
  updateSearchString,
  whichCompToRender,
}) => {
  const [salesTimeLine, setSalesTimeLine] = useState("Today");
  const [openCustomDatePick, setOpenCustomDatePick] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showInsights, setShowInsights] = useState(false);
  const [openScanner, setOpenScanner] = useState(false);

  const showIntervalTab = () => {
    let tab = document.querySelector(".chooseInterval");
    tab.classList.toggle("showInterval");
  };

  /*  let regexToMatchId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i; */
  // let regexToMatchId = ^\d{8}[0-9a-f]{32}$;

  useEffect(() => {
    console.log(displayedTimeline, "displayedTimeline checking");

    if (displayedTimeline) {
      setSalesTimeLine("Today");
      getYesterdayTrans(false);
      getCustomTrans(false);
      getTodayTrans(true);
    }
  }, [displayedTimeline]);

  const updateSalesTimeLine = (timeLine) => {
    showIntervalTab();
    console.log(timeLine);

    /* fetch the record */
    if (timeLine === "Yesterday") {
      getYesterdayTrans(true);
      getCustomTrans(false);
      getTodayTrans(false);
      setSalesTimeLine(timeLine);
      setDisplayedTimeline(null);
    } else if (timeLine === "Today") {
      getYesterdayTrans(false);
      getCustomTrans(false);
      getTodayTrans(true);
      setSalesTimeLine(timeLine);
      setDisplayedTimeline(timeLine);
    } else {
      console.log("Choose interval");
      getYesterdayTrans(false);
      /* getCustomTrans(true); */
      getTodayTrans(false);
      setOpenCustomDatePick(true);
      // setSalesTimeLine(timeLine);
      setDisplayedTimeline(null);
    }
  };

  const togglePaidTransactions = () => {
    setShowDropdown(!showDropdown);
    let tab = document.querySelector(".floai84746");
    tab.classList.toggle("showLonaTab");
  };

  return (
    <>
      <div className='searchDiv'>
        <div>
          {/* start */}

          <div className='responsiveTransTab'>
            <div className='floai84746'>
              <div onClick={togglePaidTransactions} className='highlightedTransaction'>
                {transType ? (
                  <>
                    <p className='TransactionTab'>Sales book</p>
                    <span className='transsp4rd'>{transactionCount.paid ? transactionCount.paid : 0}</span>
                  </>
                ) : (
                  <>
                    <p style={{ color: "red" }} className='TransactionTab'>
                      Credit book
                    </p>
                    <span style={{ color: "red", borderColor: "red" }} className='transsp4rd'>
                      {transactionCount.loan ? transactionCount.loan : 0}
                    </span>
                  </>
                )}
                {showDropdown ? <VscTriangleUp color={!transType && "red"} /> : <VscTriangleDown color={!transType && "red"} />}
              </div>
              <div
                onClick={() => {
                  updateTransType(!transType);
                  togglePaidTransactions();
                }}
                className={"laonRespon77"}
              >
                {transType ? (
                  <>
                    <span>Credit book</span>
                    <span style={{ borderColor: "red" }} className='transsp4rd'>
                      {transactionCount.loan ? transactionCount.loan : 0}
                    </span>
                  </>
                ) : (
                  <>
                    <span style={{ color: "#0e49b5" }}>Sales book</span>
                    <span style={{ borderColor: "#adc8fc", color: "#0e49b5" }} className='transsp4rd'>
                      {transactionCount.paid ? transactionCount.paid : 0}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
          {/* stop */}
          <div className='cashLoanTabDiv'>
            <div className={transType ? "highlightedTransaction" : ""} onClick={() => updateTransType(true)}>
              <p> Sales book </p>
              <span className='transsp4rd'>{transactionCount.paid ? transactionCount.paid : 0}</span>
            </div>

            <div className={!transType ? "highlightedTransaction" : ""} onClick={() => updateTransType(false)}>
              <p>Credit book</p>
              <span className='transsp4rd'> {transactionCount.loan ? transactionCount.loan : 0}</span>
            </div>
          </div>
          {/*  <input
            onInput={(e) => updateQueryID(e.target.value)}
            value={transID}
            type={"text"}
            onKeyDown={(e) => {
              if (e.key === "Enter" && transID.length > 12) {
                showQueriedTrans(true);
              }
            }}
            className='SearchTransact1'
            placeholder='Enter/Scan trans ID'
          /> */}
          {/* one update */}
          <div id='searchTransItem4' className=' stock-search-container searchDesktopView'>
            <Search className='stock-search-icon' size={16} />
            <input
              type='text'
              className='stock-search-input'
              placeholder='search by product or customer name'
              value={searchString}
              onChange={(e) => updateSearchString(e.target.value)}
            />
          </div>

          {/*   <span
            style={transID && transID.length > 12 ? { backgroundColor: "#AAB3F8" } : { cursor: "not-allowed", opacity: "0.5" }}
            onClick={() => {
              if (transID.length > 12) {
                showQueriedTrans(true);
              }
            }}
          >
            <BsSearch />
          </span> */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
              onClick={() => {
                setOpenScanner(true);
              }}
              className='scanBarc33'
            >
              <ScanQrCode />
            </span>
            <span
              style={{
                background: "linear-gradient(135deg, #3b82f6, #2563eb)",
                border: " none",
              }}
              onClick={() => {
                whichCompToRender("viewBookedOrderComp");
              }}
              className='scanBarc33 '
            >
              <NotebookPen color='white' size={18} />
              <span>Bookings</span>
            </span>
          </div>
          {/*  {showDropdown && (
            <div onClick={togglePaidTransactions} className
            <s='switchTransactions'>
              <p>{!transType ? "Paid transaction" : "Loan transaction"}</p>
            </div>
          )} */}
        </div>

        <div className='TransactionFilter6' style={{ display: "flex", gap: "10px" }}>
          <div className='TransFilterSearchDI'>
            {/* <Search color='gray' size={20} />
            <input className='SearcgTransMob88' placeholder='Enter/Scan Trans ID' /> */}
            <div className=' stock-search-container '>
              <Search className='stock-search-icon' size={16} />
              <input
                type='text'
                className='stock-search-input'
                placeholder='search by product or customer name'
                value={searchString}
                onChange={(e) => updateSearchString(e.target.value)}
              />
            </div>
          </div>
          <div className='TimelineTransactions'>
            <div onClick={showIntervalTab}>
              <span>{calenderIcon}</span>
              {salesTimeLine} <MdKeyboardArrowDown size={20} color='currentColor' />
            </div>
            <div className='chooseInterval'>
              {salesTimeLine !== "Today" && <p onClick={() => updateSalesTimeLine("Today")}>Today' sales</p>}
              {salesTimeLine !== "Yesterday" && !salesTimeLine.includes("-") && <p onClick={() => updateSalesTimeLine("Yesterday")}>Yesterday' sales</p>}
              <p onClick={() => updateSalesTimeLine("custom date")}>Choose interval</p>
            </div>
          </div>

          <div onClick={() => setShowInsights(true)} className='scanBarc33 insightTrans66d'>
            <BarChart3 color='#0e49b5' />
          </div>
        </div>
      </div>
      {openCustomDatePick && (
        <CustomeDateSearch closeModal={setOpenCustomDatePick} setFetchCustomTrans={getCustomTrans} setSalesTimeLine={setSalesTimeLine} disableDefault={false} />
      )}
      {showInsights && <TransactionInsights closeInsight={setShowInsights} transactionInsights={transactionInsights} />}
      {openScanner && (
        <QRScannerOverlay
          openOverlay={openScanner}
          closeOverlay={setOpenScanner}
          transID={transID}
          setTransID={updateQueryID}
          showQueriedTrans={showQueriedTrans}
        />
        /*   <QRScanner
          open={openScanner}
          onDetected={(data) => {
            updateQueryID(data);
            // do something (e.g., search transaction)
            // optionally close here if you didn't set stopAfterFirst
            console.log("QR code data:", data);
            // setOpenScanner(false);
          }}
          onClose={() => setOpenScanner(false)}
        /> */
      )}
    </>
  );
};

export default StoreSearchTab;

export const calenderIcon = (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.5 8.33341H2.5M13.3333 1.66675V5.00008M6.66667 1.66675V5.00008M6.5 18.3334H13.5C14.9001 18.3334 15.6002 18.3334 16.135 18.0609C16.6054 17.8212 16.9878 17.4388 17.2275 16.9684C17.5 16.4336 17.5 15.7335 17.5 14.3334V7.33341C17.5 5.93328 17.5 5.23322 17.2275 4.69844C16.9878 4.22803 16.6054 3.84558 16.135 3.6059C15.6002 3.33341 14.9001 3.33341 13.5 3.33341H6.5C5.09987 3.33341 4.3998 3.33341 3.86502 3.6059C3.39462 3.84558 3.01217 4.22803 2.77248 4.69844C2.5 5.23322 2.5 5.93328 2.5 7.33341V14.3334C2.5 15.7335 2.5 16.4336 2.77248 16.9684C3.01217 17.4388 3.39462 17.8212 3.86502 18.0609C4.3998 18.3334 5.09987 18.3334 6.5 18.3334Z'
      stroke='currentColor'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
